
const init={isAuth:false}

const reducer = (state=init, action) => {
 return state
};

export { reducer };
